/**
 * Развернуть на весь экран обёртку, а не `<video>`.
 *
 * Полноэкранный `<video>` прячет всё, что лежит поверх него: бейдж транспорта
 * у живой картинки и часы кадра у архива. А они обязаны быть видны всегда.
 */
export function toggleFullscreen(element: HTMLElement): void {
  if (document.fullscreenElement) {
    void document.exitFullscreen().catch(() => {});
    return;
  }
  if (element.requestFullscreen) {
    void element.requestFullscreen().catch(() => {});
    return;
  }
  // iPhone: у произвольных элементов полноэкранного режима нет, только у
  // видео. Наложения там пропадут, но это лучше, чем кнопка, которая молчит.
  const video = element.querySelector("video") as
    | (HTMLVideoElement & { webkitEnterFullscreen?: () => void })
    | null;
  video?.webkitEnterFullscreen?.();
}
